module.exports = __webpack_public_path__ + "static/media/grand_mum_closed_eye.cfe7ec07.png";